import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weebly': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M425.1 65.8C385.2 65.8 351.8 91.6 341.4 130.2 323.3 72.1 275.9 65.8 256.5 65.8 236.7 65.8 189.7 72.1 171.2 130.2 160.8 91.6 127.8 65.8 87.5 65.8 38.6 65.8 0 99.7 0 143 0 172 4.2 176.3 77.2 376.5 99.5 437.1 144.9 445.9 169.9 445.9 209.1 445.9 239.9 426.4 255.8 391.9 271.7 426.7 302.5 446.2 341.8 446.2 366.7 446.2 412.1 437.1 434.5 376.5 511.1 167.9 512 170.9 512 149.3 512.6 101 476 65.8 425.1 65.8zM451.4 180.6L385.9 357.1C377.9 378.6 364.6 394.3 339.6 394.3 316.2 394.3 302.2 381.9 295.6 360.4L256.3 243H255.4L216.1 360.4C209.1 381.9 195.2 394 172.1 394 147 394 133.7 378.3 125.8 356.8L60.9 181.6C55.5 166.7 53 157.6 53 147.1 53 130.7 68.8 117.7 91.3 117.7 110 117.7 123.3 129.5 127.4 146.7L171.4 286.6H172.4L217 149.8C223.1 130.1 233.5 117.7 256 117.7S288.9 129.8 295 149.8L339.6 286.6H340.6L384.6 146.7C388.7 129.5 402 117.7 420.7 117.7 442.9 117.7 459 131 459 153.4 458.7 161.3 454.9 169.4 451.4 180.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/weebly.js
// module id = 2Gj0
// module chunks = 144